export const MULTIPLE_CARRIERS = 'MultipleCarriers';
export const MULTIPLE_CARRIERS_IMG = 'multiple';
export const AIRLINES_PRICES_TITLES = {
  [MULTIPLE_CARRIERS]: 'FLIGHT_RESULTS_MODULE.FILTER_SECTION.MULTIPLE_CARRIERS'
};
export const DISABLED = 'DISABLED';
